import React from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Checkbox, Switch, Radio, Upload, Button, Input } from 'antd';
import { toJS } from 'mobx';
import RichTextArea from '../../../coms/rich/RichTextArea';
import validate from './validate';
import util from '../../../util';

const {
  getAccessToken,
} = util;

const {
  normFile,
  checkFileLen,
  checkLen,
} = validate;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const FormItem = Form.Item;
const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'dev-apply-form-step',
  }

  render() {
    const {
      prefixCls, form, formRequiredClass,
    } = this.props;
    let { devStore: { appDetail } } = this.props;
    appDetail = toJS(appDetail);
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };
    const { getFieldProps, isFieldValidating, getFieldError, getFieldValue } = form;
    return (
      <div className={`${prefixCls}`}>
        <FormItem
          label="应用类型："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_stype') ? '校验中...' : (getFieldError('s_stype') || []).join(', ')}>
          <CheckboxGroup {...getFieldProps('s_stype',
            {
              rules: [{ validator: checkLen },]
            }
          )}
            options={['定制', '建模', '非标', '插件']} />
        </FormItem>
        <FormItem
          label="beta版本："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_beta') ? '校验中...' : (getFieldError('s_beta') || []).join(', ')}>
          <Switch {...getFieldProps('s_beta')} checked={getFieldValue('s_beta')} />
        </FormItem>
        <FormItem
          label="版本类型："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_beta') ? '校验中...' : (getFieldError('s_beta') || []).join(', ')}>
          <RadioGroup {...getFieldProps('s_nowversion')}>
            <Radio value="0">大版本更新</Radio>
            <Radio value="1">小版本更新</Radio>
          </RadioGroup>
          <span style={{ "marginLeft": "10px" }}>[系统会自动为你生成版本号]</span>
        </FormItem>
        <FormItem
          label="使用文档："
          {...formItemLayout}>
          <Upload className={formRequiredClass} action={window.server + "/v1/appfile"} data={{ type: "usefile", access_token: getAccessToken() }}
            onPreview={(file) => file.url && window.open(`${window.server}${file.url}`)}
            {...getFieldProps('usefile', {
              valuePropName: 'fileList',
              normalize: normFile,
              rules: [{ validator: checkFileLen },]
            })}
          >
            <Button type="ghost" icon="upload">点击上传</Button>
          </Upload>
        </FormItem>
        <FormItem
          label="应用图标："
          {...formItemLayout}>
          <Upload className={formRequiredClass} action={window.server + "/v1/appfile"} listType="picture" data={{ type: "logofile", access_token: getAccessToken() }}
            accept="image/*"
            onPreview={(file) => file.url && window.open(`${window.server}${file.url}`)}
            {...getFieldProps('logofile', {
              valuePropName: 'fileList',
              normalize: normFile,
              rules: [{ validator: checkFileLen },]
            })}
          >
            {!(getFieldValue('logofile') && getFieldValue('logofile').length > 0) && (<Button type="ghost" icon="upload">点击上传</Button>)}
            <span style={{ "marginLeft": "20px" }}><a href="ui/file/imgs.rar" target="_blank">[点击下载参考图标，高270、宽270]</a></span>
          </Upload>
        </FormItem>
        <FormItem
          label="程序文件："
          {...formItemLayout}>
          <Upload className={formRequiredClass} accept=".zip" action={window.server + "/v1/appfile"} data={{ type: "appfile", access_token: getAccessToken() }}
            onPreview={(file) => file.url && window.open(`${window.server}${file.url}`)}
            {
            ...getFieldProps('appfile', {
              valuePropName: 'fileList',
              normalize: normFile,
              rules: [{ validator: checkFileLen },]
            })
            }
          >
            <Button type="ghost" icon="upload">点击上传</Button>
          </Upload>
        </FormItem>
        <FormItem
          label="源码文件："
          {...formItemLayout}>
          <Upload className={formRequiredClass} accept=".zip" action={window.server + "/v1/appfile"} data={{ type: "srcfile", access_token: getAccessToken() }}
            onPreview={(file) => file.url && window.open(`${window.server}${file.url}`)}
            {
            ...getFieldProps('srcfile', {
              valuePropName: 'fileList',
              normalize: normFile,
              rules: [{ validator: checkFileLen },]
            })
            }
          >
            <Button type="ghost" icon="upload">点击上传</Button>
          </Upload>
        </FormItem>
        <FormItem
          label="缩略图："
          {...formItemLayout}>
          <Upload className={formRequiredClass} action={window.server + "/v1/appfile"} data={{ type: "s_docfile", access_token: getAccessToken() }}
            listType='picture'
            accept="image/*"
            onPreview={(file) => file.url && window.open(`${window.server}${file.url}`)}
            {
            ...getFieldProps('sDocfile', {
              valuePropName: 'fileList',
              normalize: normFile,
              rules: [{ validator: checkFileLen },]
            })
            }
          >
            { !(getFieldValue('sDocfile') && getFieldValue('sDocfile').length > 0) && ( <Button type="ghost" icon="upload">点击上传</Button>)}
          </Upload>
        </FormItem>
        <FormItem
          label="Git@OSC账号："
          hasFeedback={getFieldValue('s_svnacc') !== ""}
          help={isFieldValidating('s_svnacc') ? '校验中...' : (getFieldError('s_svnacc') || []).join(', ')}
          {...formItemLayout}
          className={formRequiredClass}
        >
          <Input
            style={{ width: 220 }}
            {...getFieldProps('s_svnacc',
              {
                rules: [{ validator: checkLen },]
              }
            )} />
          <a href="http://git.oschina.net/" target="_blank" rel="noopener noreferrer" style={{ position: 'absolute', width: '100%', paddingLeft: 15 }}>[点击链接到注册地址，用于代码管理]</a>
        </FormItem>
        <FormItem
          label="是否自行解耦："
          {...formItemLayout}
          className={formRequiredClass}
          help={isFieldValidating('s_ispersonal') ? '校验中...' : (getFieldError('s_ispersonal') || []).join(', ')}>
          <Switch {...getFieldProps('s_ispersonal')} checked={getFieldValue('s_ispersonal')} />
        </FormItem>
        <FormItem
          label="更新日志："
          {...formItemLayout}
          help={isFieldValidating('s_versiondesc') ? '校验中...' : (getFieldError('s_versiondesc') || []).join(', ')}
        >
          <RichTextArea className={formRequiredClass} {...getFieldProps('s_versiondesc', {
            initialValue: appDetail.s_versiondesc,
            rules: [{ validator: checkLen }]
          })} />
        </FormItem>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/devApply/Form_step_3.js